import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './app';

window.APP_GLOBALS = {}
const rootElement = document.getElementById('root');
if (rootElement) {
  createRoot(rootElement).render(<App />);
}
